import { useContext, useState } from 'react';
import clsx from 'clsx';
import * as R from 'ramda';

import CreateWorkModal from '@atom/components/common/createWorkModals/CreateWorkModal';
import NewWorkOrderIcon from '@atom/components/common/svgIcons/NewWorkOrderIcon';
import workExportsIcon from '@atom/components/common/svgIcons/workExports.svg';
import workTypeIcon from '@atom/components/common/svgIcons/workTypeIcon.svg';
import { useNavigation } from '@atom/hooks/useNavigation';
import { usePreferences } from '@atom/hooks/usePreferences';
import { WorkOrdersView } from '@atom/hooks/useWorkOrdersFilters';
import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import WorkOrdersContext from './WorkOrdersContext';
import WorkOrdersExport from './WorkOrdersExport';

import classes from './workOrders.module.css';

const WorkOrdersHeader = () => {
  const [, { Link }] = useNavigation();
  const preferences = usePreferences();
  const requireWorkType = R.pathOr(
    false,
    ['workOrders', 'requireWorkType'],
    preferences,
  );

  const { input, setInput } = useContext(WorkOrdersContext);

  const [createWorkModalOpen, setCreateWorkModalOpen] =
    useState<boolean>(false);

  const toggleCreateWorkModal = () => {
    setCreateWorkModalOpen(!createWorkModalOpen);
  };

  return (
    <div className={classes.headerContainer}>
      <div className={classes.leftContainer}>
        <div className={classes.nameContainer}>Work</div>
        <div>
          {Object.values(WorkOrdersView).map((view, key) => (
            <div
              key={key}
              onClick={() => setInput({ ...input, view })}
              className={clsx(
                classes.tabButton,
                input.view === view && classes.selected,
              )}
            >
              {view}
            </div>
          ))}
        </div>
      </div>
      <div className={classes.buttonContainer}>
        {hasRolePermissions(ROLE_SETS.INSPECTOR) && (
          <>
            <IconButton
              tooltip="Create Work"
              onClick={toggleCreateWorkModal}
              children={<NewWorkOrderIcon />}
              data-cy="workOrdersHeaderCreateWorkButton"
            />
            <CreateWorkModal
              redirectOnCreate
              open={createWorkModalOpen}
              workTemplateRequired={requireWorkType}
              onClose={() => setCreateWorkModalOpen(false)}
            />
          </>
        )}
        {hasRolePermissions(ROLE_SETS.INSPECTOR) && <WorkOrdersExport />}
        {hasRolePermissions(ROLE_SETS.INSPECTOR) && (
          <Link to="/workExports">
            <IconButton
              tooltip="Work Exports"
              data-cy="workOrdersHeaderWorkExportsButton"
            >
              <Icon>
                <img src={workExportsIcon} />
              </Icon>
            </IconButton>
          </Link>
        )}
        {hasRolePermissions(ROLE_SETS.INSPECTOR) && (
          <Link to="/form-repository">
            <IconButton tooltip="Forms" data-cy="workOrdersHeaderFormsButton">
              <Icon color={colors.neutral.white}>library_books</Icon>
            </IconButton>
          </Link>
        )}
        <Link to="/work-templates">
          <IconButton
            tooltip="Work Templates"
            data-cy="workOrdersHeaderWorkTemplatesButton"
          >
            <img src={workTypeIcon} />
          </IconButton>
        </Link>
      </div>
    </div>
  );
};

export default WorkOrdersHeader;
